import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-settings"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(-0.375 -0.375)",
      class: ""
    }, [
      _createElementVNode("circle", {
        cx: "22.4",
        cy: "22.4",
        r: "3",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M29.8,25.4c-0.3,0.6-0.1,1.3,0.3,1.8l0.1,0.1c0.8,0.8,0.8,2,0,2.8s-2,0.8-2.8,0L27.3,30\n\t\tc-0.7-0.6-1.7-0.6-2.4,0c-0.3,0.3-0.5,0.7-0.5,1.1v0.2c0,1.1-0.9,2-2,2s-2-0.9-2-2v-0.1c0-0.7-0.4-1.3-1.1-1.5\n\t\tc-0.6-0.3-1.3-0.1-1.8,0.3l-0.1,0.1c-0.8,0.8-2,0.8-2.8,0s-0.8-2,0-2.8l0.1-0.1c0.6-0.7,0.6-1.7,0-2.4c-0.3-0.3-0.7-0.5-1.1-0.5\n\t\th-0.2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h0.1c0.7,0,1.3-0.4,1.5-1.1c0.3-0.6,0.1-1.3-0.3-1.8l-0.1-0.1c-0.8-0.8-0.8-2,0-2.8\n\t\ts2-0.8,2.8,0l0.1,0.1c0.5,0.5,1.2,0.6,1.8,0.3h0.1c0.6-0.3,1-0.9,1-1.5v-0.2c0-1.1,0.9-2,2-2s2,0.9,2,2v0.1c0,0.9,0.8,1.7,1.7,1.6\n\t\tc0.4,0,0.8-0.2,1.1-0.5l0.1-0.1c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8L30,17.5c-0.5,0.5-0.6,1.2-0.3,1.8v0.1c0.3,0.6,0.9,1,1.5,1h0.2\n\t\tc1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2h-0.1C30.6,24.4,30,24.8,29.8,25.4z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }